// extracted by mini-css-extract-plugin
export default {"wrapper":"TeasePopup_wrapper__yzVPO","popup":"TeasePopup_popup__vxLzU"};